module.exports = __webpack_public_path__ + "static/media/dwIcon.cc2dab7a.svg";